enum AiAssistUsageSorting {
  ByName = 'ByName',
  ByUsageCount = 'ByUsageCount',
  ByDate = 'ByDate',
}

export default AiAssistUsageSorting;
